import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=45c8edc9&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=45c8edc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8edc9",
  null
  
)

export default component.exports